// Cambodia eVisa (https://www.evisa.gov.kh). Option values are the government form's exact option
// texts so the engine (gov-engine KHeVisa) selects them verbatim.

const KH_OCCUPATIONS = [
	"Student",
	"Teacher",
	"Farmer",
	"Journalist",
	"Government official",
	"Company employee",
	"Military personnel",
	"Retired",
	"Religious personnel",
	"Member of parliament",
	"Crew member",
	"NGO staff",
	"Artist",
	"Self-employed",
	"Worker",
	"Police officer",
	"Other"
].map((label) => ({ label, value: label }))

// Ports of entry offered to eVisa holders. "Cham Yeam (Koh Kong)" and "Poi Pet (Banteay Meanchey)" are
// listed on the form but disabled, so they are not offered here.
const KH_PORTS_OF_ENTRY = [
	"Techo International Airport (KTI)",
	"Siem Reap Angkor International Airport (SAI)",
	"Sihanoukville International Airport (Not Cruising Ships)",
	"Bavet (Svay Rieng)",
	"Tropaeng Kreal Border Post (Stung Treng)"
].map((label) => ({ label, value: label }))

export const KH_FIELDS = {
	occupation: {
		type: "select",
		props: {
			label: "Occupation",
			options: KH_OCCUPATIONS
		}
	}
}

export const KH_APPLICATION_FIELDS = {
	port_of_entry: {
		type: "select",
		props: {
			label: "Port of Entry",
			options: KH_PORTS_OF_ENTRY
		}
	},
	address_during_visit: {
		type: "textarea",
		props: {
			label: "Address During Visit (hotel name, street, city)",
			maxLength: 240
		}
	},
	bank_statement: {
		props: {
			type: "pdf_document",
			message: "Please upload your bank statements for the last 3 months.",
			friendly_name: "Bank Statements (last 3 months)"
		}
	},
	return_ticket: {
		props: {
			type: "pdf_document",
			message: "Please take a picture or upload a copy of your flight or bus ticket out of Cambodia.",
			friendly_name: "Flight or Bus Ticket Out of Cambodia"
		}
	}
}
